// extracted by mini-css-extract-plugin
export default {"container":"SO-z","disabled":"TO-z"};